import { useDroppable } from "@dnd-kit/core";

interface RemoveDropZoneProps {
    id: string;
    isVisible: boolean;
    layout: "horizontal" | "vertical";
}

export default function RemoveDropZone({ id, isVisible, layout }: RemoveDropZoneProps) {
    const { setNodeRef, isOver } = useDroppable({
        id,
        data: { type: "remove-zone" },
    });

    if (!isVisible) return null;

    const baseClasses = "flex items-center justify-center border-2 border-dashed rounded-lg transition-colors text-xs font-medium";
    const colorClasses = isOver
        ? "border-red-400 bg-red-50 text-red-600"
        : "border-gray-300 bg-gray-50 text-gray-400";
    const layoutClasses = layout === "horizontal"
        ? "px-4 py-1 whitespace-nowrap"
        : "px-3 py-3 mt-1";

    return (
        <div ref={setNodeRef} className={`${baseClasses} ${colorClasses} ${layoutClasses}`}>
            {isOver ? "Release to remove" : "Drag here to remove"}
        </div>
    );
}
